import { render, staticRenderFns } from "./modal-navigation.vue?vue&type=template&id=9d8c747e&scoped=true&"
import script from "./modal-navigation.vue?vue&type=script&lang=js&"
export * from "./modal-navigation.vue?vue&type=script&lang=js&"
import style0 from "./modal-navigation.vue?vue&type=style&index=0&id=9d8c747e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8c747e",
  null
  
)

export default component.exports